require('@glidejs/glide/dist/css/glide.core.css');
import Glide from '@glidejs/glide';

if (parseInt(_slider) > 0) {
    new Glide('#partners', {
        type: 'carousel',
        startAt: 0,
        perView: 8,
        rewind: true,
        autoplay: 1500,
        peek: { before: 0, after: 100 } ,
        breakpoints: {
            1700: {
                perView: 5
            },
            1200: {
                perView: 4
            },
            800: {
                perView: 3
            }
        }
    }).mount();

}

const mapSpinner = document.getElementById('map_spinner');
let mapObj;
let objData;
const sideInfo = document.getElementById('side_info');
let timetable = false;
const mapData = {
    availableCountries: [],
    ports: [],
    routes: [],
    markers: [],
    selectedCountry: '',
    selectedPort: '',
    selectedRoute: '',
    highlightedRoutes: [],
    selectedCountryDestinations: []
};

$(document).ready(() => {

    const GeoJSON = _json_url;
    const customStyle = {
        stroke: true,
        color: '#fff',
        weight: 1,
        opacity: 0.7,
        fill: true,
        fillColor: '#cecece',
        fillOpacity: 1
    };


    $.post('/ports/getdata', {_token: _token}).done((res) => {
        if (res.status === 'OK') {
            mapData.availableCountries = res.availableCountries;
            mapData.ports = res.ports;
            mapData.routes = res.routes;
        }

        $.getJSON(GeoJSON, function (data) {
            const map = L.map(_map, {
                scrollWheelZoom: false
            }).setView([46, -3], 4);
            mapObj = map;
            objData = data;

            L.geoJson(data, {
                clickable: false,
                style: customStyle,
                onEachFeature: onEachFeature
            }).addTo(map);

            //hide the spinner
            mapSpinner.classList.add('d-none');

            mapData.ports.forEach((e) => {
                if (typeof e.icon !== 'undefined') {
                    var icon = L.icon({
                        iconUrl: e.icon,
                        iconSize: [16, 16],
                    });
                }

                const marker = L.marker([e.lat, e.long], {icon: icon, title: e.info});
                marker._id = e.id
                marker._country = e.country
                marker._idNazione = e.idNazione
                setIdNazione(marker);
                marker.on({click: highlightMarker});
                marker.addTo(map);
                mapData.markers.push(marker);

                //if (typeof e.info !== 'undefined') {
                //    marker.bindPopup(e.info);
                //}
            });
            //add labels
            map.createPane('labels');
            map.getPane('labels').style.zIndex = 650;
            map.getPane('labels').style.pointerEvents = 'none';

            // const Stamen_TerrainLabels = L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/terrain-labels/{z}/{x}/{y}{r}.{ext}', {
            //     attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            //     subdomains: 'abcd',
            //     pane: 'labels',
            //     minZoom: 0,
            //     maxZoom: 18,
            //     className: '',
            //     ext: 'png'
            // });
            //
            // Stamen_TerrainLabels.addTo(map);


            // mapObj.on('zoomend', () => {
            //     Object.values(mapObj._layers).forEach((layer) => {
            //         if (typeof layer.feature !== 'undefined') {
            //
            //             if (mapData.availableCountries.indexOf(layer.feature.properties.iso_a2) > -1) {
            //                 countryLabels(layer.feature, layer);
            //             }
            //         }
            //     });
            // });

        });

    }).fail((res) => {
        //
    });


});

function onEachFeature(feature, layer) {
    if (mapData.availableCountries.indexOf(feature.properties.iso_a2) > -1) {
        availableFeature(feature, layer);
    }
    layer.on({
        click: highlightFeature
        // mouseover: ,
        // mouseout: ,
    });
}

function highlightFeature(e) {
    const layer = e.target;
    const countryIso = layer.feature.properties.iso_a2;
    const countryIdNazione = layer.feature.properties.idNazione;
    const selectedCountryIso = mapData.selectedCountry !== '' ? mapData.selectedCountry.feature.properties.iso_a2 : '';
    const available = mapData.availableCountries.indexOf(countryIso) > -1;
    // const selected = layer.options.fillColor === '#3cdbc0';
    let selected = false;
    selected = typeof mapData.selectedCountry.feature !== 'undefined' && countryIso === selectedCountryIso;
    const isHighlighted = layer.options.fillColor === '#3cdbc0';

    if (available) {
        //if any routes
        if (mapData.highlightedRoutes.length) {
            mapData.highlightedRoutes.forEach((r) => r.remove());
            mapData.selectedCountryDestinations = [];
        }
        if (selected && isHighlighted) {
            layer.setStyle({
                stroke: true,
                color: '#fff',
                weight: 1,
                opacity: 0.7,
                fill: true,
                fillColor: '#fee019',
                fillOpacity: 1
            });

            if (layer._leaflet_id === mapData.selectedCountry._leaflet_id) {
                mapData.selectedCountry = '';
            }
            if (mapData.selectedCountry !== '') {
                // mapData.markers.forEach((marker) => {
                //     if (countryIso === marker._country) {
                //         marker._icon.hidden = true;
                //     }
                // });
            } else {
                mapData.markers.forEach((marker) => {
                    // marker._icon.hidden = false;
                    marker._icon.src = _red_icon;
                });
            }
        } else {

            renderCountryInfo(countryIdNazione);

            layer.setStyle({
                stroke: true,
                color: '#fff',
                weight: 1,
                opacity: 0.7,
                fill: true,
                fillColor: '#3cdbc0',
                fillOpacity: 1
            });
            layer.bringToFront();

            if (mapData.selectedCountry !== '' && countryIso !== selectedCountryIso) {
                mapData.selectedCountry.setStyle({
                    stroke: true,
                    color: '#fff',
                    weight: 1,
                    opacity: 0.7,
                    fill: true,
                    fillColor: '#fee019',
                    fillOpacity: 1
                });
                // mapData.selectedCountry.bringToFront();
            }
            mapData.selectedCountry = layer;

            //clear markers
            mapData.markers.forEach((marker) => {
                marker._icon.src = _red_icon;
            });

            mapData.markers.forEach((marker) => {
                if (countryIso !== marker._country) {
                    // marker._icon.hidden = true;
                } else {
                    // marker._icon.hidden = false;
                    // marker._icon.src = _green_icon;
                    highlightMarker(marker, true);
                }
            });
        }
    }

    // layer.bringToFront();
}

function availableFeature(feature, layer) {

    //country lables
    countryLabels(feature, layer);

    layer.setStyle({
        stroke: true,
        color: '#fff',
        weight: 1,
        opacity: 0.7,
        fill: true,
        fillColor: '#fee019',
        fillOpacity: 1
    });

    layer.bringToFront();
}

function highlightMarker(e, fromCountry = false) {
    const pointer = fromCountry ? e:e.target;
    const portId = pointer._id;
    let country = '';
    const icon = pointer._icon;
    const routes = {};

    icon.src = _white_icon;

    //clear markers
    if (!fromCountry) {
        mapData.selectedPort = portId;
        renderPortInfo(portId);
        //if any routes
        if (mapData.highlightedRoutes.length) {
            mapData.highlightedRoutes.forEach((r) => r.remove());
            mapData.selectedCountryDestinations = [];
        }
        mapData.markers.forEach((marker) => {
            if (marker._id !== portId) {
                // marker._icon.hidden = true;
                marker._icon.src = _red_icon;
            }
        });
    }

    Object.values(mapObj._layers).forEach((layer) => {

        if (typeof layer.feature !== 'undefined') {
            if (layer.feature.properties.iso_a2 === pointer._country) {
                country = layer;
            }
        }
    });

    mapData.routes.forEach((e) => {
        //upd: added ||
        if (portId === e.IDPortoPartenza) {
            mapData.selectedCountryDestinations.push(e.IDPortoArrivo);
            routes[`${e.IDPortoPartenza}-${e.IDPortoArrivo}`] = [
                [e.PortoPartenzaLatitude, e.PortoPartenzaLongitude],
                [e.PortoArrivoLatitude, e.PortoArrivoLongitude]
            ];
        }
        if (portId === e.IDPortoArrivo) {
            mapData.selectedCountryDestinations.push(e.IDPortoPartenza);
            routes[`${e.IDPortoPartenza}-${e.IDPortoArrivo}`] = [
                [e.PortoPartenzaLatitude, e.PortoPartenzaLongitude],
                [e.PortoArrivoLatitude, e.PortoArrivoLongitude]
            ];
        }
        // if (portId === e.IDPortoArrivo) {
        //
        //     routes[`${e.IDPortoPartenza}-${e.IDPortoArrivo}`] = [
        //         [e.PortoPartenzaLatitude, e.PortoPartenzaLongitude],
        //         [e.PortoArrivoLatitude, e.PortoArrivoLongitude]
        //     ];
        // }
    });

    //clear style for now
    if (!fromCountry && mapData.selectedCountry !== '') {
        mapData.selectedCountry.setStyle({
            stroke: true,
            color: '#fff',
            weight: 1,
            opacity: 0.7,
            fill: true,
            fillColor: '#fee019',
            fillOpacity: 1
        });
    }
    mapData.selectedCountry = country;

    //show new markers
    mapData.markers.forEach((m) => {
        if (mapData.selectedCountryDestinations.indexOf(m._id) > -1) {
            const selectedCountryId = mapData.selectedCountry.feature.properties.iso_a2;
            const markerCountry = m._country;
            m._icon.src = selectedCountryId === markerCountry
                ? _white_icon
                : _green_icon;
            m._icon.hidden = false;
        }
    });

    Object.entries(routes).forEach((r) => {
        const route = L.polyline(r[1], {color: '#1d9c87', weight: 1}).addTo(mapObj);
        route._route = r[0];
        route.bringToFront();
        route.on({click: routeInfo});
        mapData.highlightedRoutes.push(route);
    });

}

function setIdNazione(marker) {
    const layer = mapObj._layers;
    Object.values(layer).forEach((l) => {
        if (typeof l.feature !== 'undefined' && l.feature.properties.iso_a2 === marker._country) {
            l.feature.properties.idNazione = marker._idNazione;
        }
    });
}

function inverseRouteListener() {
    //inverse route when the user clicks on arrows between port names

}

function routeInfo(e) {
    let route = e.target._route;
    const routePorts = route.split('-');

    if (mapData.selectedPort === routePorts[1]) {
        const routes = mapData.routes.filter((r) => r.IDPortoArrivo === routePorts[0] && r.IDPortoPartenza === routePorts[1]);
        if (routes.length) {
            route = `${routePorts[1]}-${routePorts[0]}`;
        }
    }

    //render route info
    renderRouteInfo(route);

    //put the selected route in the object
    mapData.selectedRoute = route;
}

function renderCountryInfo(country) {

    return false;

    $.post('/ports/renderinfo', {_token: _token, requestedFor: 'country', id: country}).done((res) => {
        if (res.status === 'OK') {
            sideInfo.innerHTML = res.render;
        }
    }).fail((res) => {
        //
    });
}

function renderPortInfo(port) {

    return false;

    $.post('/ports/renderinfo', {_token: _token, requestedFor: 'port', id: port}).done((res) => {
        if (res.status === 'OK') {
            sideInfo.innerHTML = res.render;
        }
    }).fail((res) => {
        //
    });
}

function renderRouteInfo(route) {

    return false;

    $.post('/ports/renderinfo', {_token: _token, requestedFor: 'route', id: route}).done((res) => {
        if (res.status === 'OK') {
            sideInfo.innerHTML = res.render;

            console.log(document.getElementById('routeInfo').offsetHeight);
            // $('#side_info').html(res.render);

        }
        getRouteTimetables(route);
    }).fail((res) => {
        //
    });

    //add event listener to inverse the route
    setTimeout(() => {
        let route = mapData.selectedRoute;
        const arrowsElement = document.getElementById('inverseRoute');
        arrowsElement.addEventListener('click', function() {

            arrowsElement.classList.add('d-none');
            document.getElementById('arrowSpinner').classList.add('spinner-border','spinner-border-sm');

            const routePorts = route.split('-');
            const routes = mapData.routes.filter((r) => r.IDPortoArrivo === routePorts[0] && r.IDPortoPartenza === routePorts[1]);
            if (routes.length) {
                route = `${routePorts[1]}-${routePorts[0]}`;
                renderRouteInfo(route);

                //put the selected route in the object
                mapData.selectedRoute = route;
            } else {
                Swal.fire({
                    showCloseButton: true,
                    title: 'route not available',
                    showCancelButton: false,
                    width: '50rem',
                    customClass: {
                        confirmButton: 'btn btn-lg back_rose m-sm-4 m-md-2 w_trip',
                        cancelButton: 'btn btn-lg back_trip m-sm-4 m-md-2 w_trip',
                        title: 'h4 my-4',}
                });
            }
        });
    }, 1000);
}

function getRouteTimetables(route) {
    const popup = document.getElementById('timetables');
    $.post('/ports/timetable', {_token: _token, route: route}).done((res) => {
        if (res.status === 'OK') {
            timetable = res.render;
            if (res.show) {
                popup.classList.remove('d-none');
            }
        }
    }).fail((res) => {
        popup.classList.add('d-none');
        timetable = false;
    });
}

function showRouteTimetables(){
    if (timetable) {
        Swal.fire({
            showCloseButton: true,
            title: _timetablesTitle,
            html: timetable,
            showCancelButton: true,
            showConfirmButton: false,
            buttonsStyling: false,
            cancelButtonText: _back_to_map,
            cancelButtonAriaLabel: _back_to_map,
            width: '60rem',
            customClass: {
                cancelButton: 'btn btn-lg back_trip m-sm-4 m-md-2 w_trip',
                title: 'h2 my-4 color_blu font-weight-trip',
            }
        });
    }
}

globalThis.showRouteTimetables = showRouteTimetables;

function countryLabels(feature, layer) {
    const lang = typeof _lang_iso !== 'undefined' && _lang_iso !== 'en' ? `name_${_lang_iso}` : 'name';

    const zoomLevel = mapObj.getZoom();
    const availableZoomLevel = feature.properties.min_label && feature.properties.max_label
        ? {
            min_label: feature.properties.min_label,
            max_label: feature.properties.max_label
        }
        : false


    if (feature.properties.label_x && feature.properties.label_y) {

        const tooltip = L.tooltip({
            permanent: true,
            direction: 'center',
            className: 'custom-tooltip'
        })
            .setLatLng([feature.properties.label_y, feature.properties.label_x])
            .setContent(feature.properties[lang])
            .addTo(mapObj);

        // if (availableZoomLevel && (zoomLevel >= availableZoomLevel.min_label && zoomLevel <= availableZoomLevel.max_label)) {
        //
        //     const tooltip = L.tooltip({
        //         permanent: true,
        //         direction: 'center',
        //         className: 'custom-tooltip'
        //     })
        //         .setLatLng([feature.properties.label_y, feature.properties.label_x])
        //         .setContent(feature.properties[lang])
        //         .addTo(mapObj);
        // } else {
        //     mapObj.eachLayer(function(layer) {
        //         if (layer instanceof L.Tooltip) {
        //             mapObj.removeLayer(layer);
        //         }
        //     });
        // }
    } else {
        layer.bindTooltip(feature.properties[lang], {
            permanent: true,
            direction: 'center',
            className: 'custom-tooltip'  //custom class name
        }).openTooltip();

        // if (availableZoomLevel && (zoomLevel >= availableZoomLevel.min_label && zoomLevel <= availableZoomLevel.max_label)) {
        //
        //     layer.bindTooltip(feature.properties[lang], {
        //         permanent: true,
        //         direction: 'center',
        //         className: 'custom-tooltip'  //custom class name
        //     }).openTooltip();
        // }
    }
}
